// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"885":"868c4a4f","1575":"868c4a4f","5846":"868c4a4f","5903":"868c4a4f","8099":"868c4a4f"}[chunkId] + ".chunk.css";
};